import { getAppCodes, getModulePermissions } from './decodeJWT';
import { Rule } from '../types';

const getModulePermissionsData = async () => {
	const appCodes: string[] = await getAppCodes();
	const modulePermissions: string[] = await getModulePermissions();

	return { appCodes, modulePermissions };
};

export const getBynderAIRules = async () => {
	const { appCodes, modulePermissions } = await getModulePermissionsData();

	return parseBynderAIPermissions(modulePermissions, appCodes);
};

const parseBynderAIPermissions = (permissions: string[], appCodes: string[]) => {
	const permissionsList: Rule[] = [];
	permissions
		.map((permission) => permission.split('.'))
		.filter((parts) => parts[0] === 'bynder_ai')
		.forEach((parts) => {
			if (parts[1] === 'agents' && appCodes.includes('BAI')) {
				if (parts[2] === 'manage' || parts[2] === 'run') {
					permissionsList.push({ action: parts[2], subject: 'bynder_ai_agents' });
				}
			}
		});

	return permissionsList;
};
